export const LANGUAGES = {
    it: 'it',
    de: 'de',
    en: 'en',
    es: 'es',
    fr: 'fr',
};
//# sourceMappingURL=constants.js.map